import { useState, useCallback, useEffect } from 'react';

export const UserTypeEnum = Object.freeze({
  ADMIN: 'ADMIN',
  USER: 'USER',
});

export const GameAccessEnum = Object.freeze({
  FULL: 8,
  HALF: 3,
});

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const handler = useCallback(
    () =>
      setTimeout(() => {
        setDebouncedValue(value);
      }, delay),
    [delay, value]
  );

  useEffect(() => {
    handler();

    return () => {
      clearTimeout(handler());
    };
  }, [handler]);

  return debouncedValue;
}
